// Company suffixes that follow a comma inside one name ("Acme, Inc."), so
// that comma doesn't start a new name.
const NAME_SUFFIX =
  /^(inc|incorporated|llc|ltd|limited|corp|corporation|co|plc|gmbh|ag|sa|ab|bv|nv|lp|llp|pbc)\.?$/i;

/**
 * The names in a pasted list. A list on several lines (or tab-separated, as a
 * spreadsheet row copies) has one name per cell and keeps each name's own
 * commas; a single line is split on commas and semicolons.
 */
export const splitNameList = (text: string): string[] => {
  const cells = text
    .split(/[\r\n\t]+/)
    .map((cell) => cell.replace(/[,;\s]+$/, "").trim())
    .filter(Boolean);

  let names = cells;
  if (cells.length === 1) {
    names = [];
    for (const part of cells[0].split(/[,;]/)) {
      const name = part.trim();
      if (!name) continue;
      if (names.length && NAME_SUFFIX.test(name)) {
        names[names.length - 1] += `, ${name}`;
      } else {
        names.push(name);
      }
    }
  }

  const seen = new Set<string>();
  return names.filter((name) => {
    const key = name.toLowerCase();
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};
